import { FeatureFlag, isFeatureEnabled } from 'Utils/FeatureFlags';

export const isRepertoireLibraryAvailable = () =>
  isFeatureEnabled(FeatureFlag.USE_REPERTOIRE_LIBRARY);
